import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal, inject } from '@angular/core'
import { WidgetInterface } from '@modules/widgets-module/interfaces/widget.interface'
import { OrdersSettingsInterface } from '@shared/components/trading/widgets/orders-widget/core/interfaces/orders-settings.interface'
import { PostTradingEventTypeEnum } from '@modules/options-module/post-trading/enums/post-trading-event-type.enum'
import { OptionOrderTypeEnum } from '@modules/options-module/orders/enums/option-order-type.enum'
import { DropdownColumnsActionsComponent } from '@shared/components/trading/widgets/common/dropdown-columns-actions/dropdown-columns-actions.component'
import { ColumnInterface } from '@shared/interfaces/column.interface'
import { ColumnsPostTradingExercisesEnum } from '@shared/components/trading/widgets/orders-widget/core/enums/post-trading/columns-post-trading-exercises.enum'
import { ColumnsPostTradingAssignedEnum } from '@shared/components/trading/widgets/orders-widget/core/enums/post-trading/columns-post-trading-assigned.enum'
import { ColumnsPostTradingExpiredEnum } from '@shared/components/trading/widgets/orders-widget/core/enums/post-trading/columns-post-trading-expired.enum'
import { WidgetsService } from '@modules/widgets-module/services/widgets.service'
import { UseLocales } from '@modules/lang-module/decorators/use-locales'
import ru from './core/locale/ru.json'
import en from './core/locale/en.json'

@UseLocales({ ru, en })
@Component({
	selector: 'app-dropdown-columns-orders-post-trading',
	templateUrl: './dropdown-columns-orders-post-trading.component.html',
	styleUrl: './dropdown-columns-orders-post-trading.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [DropdownColumnsActionsComponent],
})
export class DropdownColumnsOrdersPostTradingComponent {
	protected readonly postTradingEventTypeEnum: typeof PostTradingEventTypeEnum = PostTradingEventTypeEnum
	protected readonly optionOrderTypeEnum: typeof OptionOrderTypeEnum = OptionOrderTypeEnum

	public widget: InputSignal<WidgetInterface<OrdersSettingsInterface> | null> =
		input<WidgetInterface<OrdersSettingsInterface> | null>(null)

	private readonly _widgetsService: WidgetsService = inject<WidgetsService>(WidgetsService)

	protected exercisesColumns: Signal<ColumnInterface<ColumnsPostTradingExercisesEnum>[]> = computed<
		ColumnInterface<ColumnsPostTradingExercisesEnum>[]
	>((): ColumnInterface<ColumnsPostTradingExercisesEnum>[] => {
		const widget: WidgetInterface<OrdersSettingsInterface> | null = this.widget()

		return widget?.settings.options.postTrading.exercises.columns ?? []
	})

	protected assignedColumns: Signal<ColumnInterface<ColumnsPostTradingAssignedEnum>[]> = computed<
		ColumnInterface<ColumnsPostTradingAssignedEnum>[]
	>((): ColumnInterface<ColumnsPostTradingAssignedEnum>[] => {
		const widget: WidgetInterface<OrdersSettingsInterface> | null = this.widget()

		return widget?.settings.options.postTrading.assigned.columns ?? []
	})

	protected expiredColumns: Signal<ColumnInterface<ColumnsPostTradingExpiredEnum>[]> = computed<
		ColumnInterface<ColumnsPostTradingExpiredEnum>[]
	>((): ColumnInterface<ColumnsPostTradingExpiredEnum>[] => {
		const widget: WidgetInterface<OrdersSettingsInterface> | null = this.widget()

		return widget?.settings.options.postTrading.expired.columns ?? []
	})
	protected onChangeExercisesColumns(columns: ColumnInterface<ColumnsPostTradingExercisesEnum>[]): void {
		const widget: WidgetInterface<OrdersSettingsInterface> | null = this.widget()
		if (!widget) return

		this._widgetsService.updateWidget({
			...widget,
			settings: {
				...widget.settings,
				options: {
					...widget.settings.options,
					postTrading: {
						...widget.settings.options.postTrading,
						exercises: { columns },
					},
				},
			},
		})
	}

	protected onChangeAssignedColumns(columns: ColumnInterface<ColumnsPostTradingAssignedEnum>[]): void {
		const widget: WidgetInterface<OrdersSettingsInterface> | null = this.widget()
		if (!widget) return

		this._widgetsService.updateWidget({
			...widget,
			settings: {
				...widget.settings,
				options: {
					...widget.settings.options,
					postTrading: {
						...widget.settings.options.postTrading,
						assigned: { columns },
					},
				},
			},
		})
	}

	protected onChangeExpiredColumns(columns: ColumnInterface<ColumnsPostTradingExpiredEnum>[]): void {
		const widget: WidgetInterface<OrdersSettingsInterface> | null = this.widget()
		if (!widget) return

		this._widgetsService.updateWidget({
			...widget,
			settings: {
				...widget.settings,
				options: {
					...widget.settings.options,
					postTrading: {
						...widget.settings.options.postTrading,
						expired: { columns },
					},
				},
			},
		})
	}
}
